<template>
  <el-dialog title="提示" :visible.sync="uploadVisible" width="30%" :close-on-click-modal="false" :show-close="false">
    <el-upload
      class="upload-demo"
      drag
      :action="`/${process.env.VUE_APP_CONTENT_PATH}/file/uploadExcel.do`"
      :on-change="onChange"
      :before-remove="onRemove"
      :multiple="false"
      :auto-upload="false"
      limit="1"
      :on-exceed="onExceed"
      ref="upload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div class="el-upload__tip" slot="tip">上传模板只能是 xls、xlsx格式!</div>
    </el-upload>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelModal">取 消</el-button>
      <el-button type="primary" @click="uploadExcelFile" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    uploadVisible: Boolean,
  },
  data() {
    return {
      files: null,
      fileName: "",
      loading: false,
    };
  },
  methods: {
    cancelModal() {
      this.$emit("closeUploadFile");
      this.files = null;
      this.fileName = "";
      this.$refs.upload.clearFiles();
    },

    onChange(file) {
      console.log(file, this.fileName);
      this.files = file.raw;
      const extension = file.raw.name.split(".")[1] === "xls";
      const extension2 = file.raw.name.split(".")[1] === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 5;
      if (!extension && !extension2) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return;
      }
      this.fileName = file.raw.name;
    },
    onRemove() {
      this.files = null;
      this.fileName = "";
    },
    onExceed() {
      this.$message.warning("单个文件上传");
    },
    uploadExcelFile() {
      if (this.fileName == "") {
        this.$message.warning("请选择上传文件");
        return;
      }
      let fileFormData = new FormData();
      fileFormData.append("file", this.files, this.fileName); //filename是键，file是值，就是要传的文件，test.zip是要传的文件名
      this.loading = true;
      this.$store.dispatch("sendFile", {
        param: fileFormData,
        cb: (code) => {
          if (code == "0000") {
            this.$notify({
              title: "提示",
              message: "上传成功",
              type: "success",
            });
            this.$emit("closeUploadFile");
            this.files = null;
            this.fileName = "";
          }
          this.loading = false;
        },
      });
    },
  },
};
</script>
